import React from "react";
import clsx from "clsx";
import MenuItem from "./MenuItem";
import useBuildingMenuOptions from "features/Building/BuildingMenu/useBuildingMenuOptions";
import ConfirmModal from "components/ConfirmModal";
import { buildingStore } from "store/Building/BuildingStore";
import { observer } from "mobx-react-lite";

const BuildingMenu = () => {
  const { options, rightOptions } = useBuildingMenuOptions();

  return (
    <>
      <div className="sticky top-[64px] flex border-b h-[56px] bg-white shadow-sm px-6 z-10 max-w-full">
        <div className="flex justify-between w-full items-center relative">
          <div
            className={clsx(
              "z-10 print:hidden flex items-center",
              "border-gray-300 text-gray-500 hover:text-gray-700 overflow-x-auto relative pr-40"
            )}
          >
            {options.map((rec, index) => (
              <MenuItem key={index} item={rec} />
            ))}
          </div>
          <div className="absolute right-0 flex top-0 z-20 h-full">
            <div className="w-7 bg-gradient-to-r from-transparent to-white"></div>
            <div className="flex items-center bg-white">
              {rightOptions.map((rec, index) => (
                <MenuItem key={index} item={rec} />
              ))}
            </div>
          </div>
        </div>
        {buildingStore.openMenuConfrimModal?.open && (
          <ConfirmModal
            type="info"
            open={Boolean(buildingStore.openMenuConfrimModal?.open)}
            close={buildingStore.openMenuConfrimModal?.close}
            confirmButtonTitle={
              buildingStore.openMenuConfrimModal?.confirmButtonTitle
            }
            onConfirm={buildingStore.openMenuConfrimModal?.confirm}
            descriptionMesage={buildingStore.openMenuConfrimModal?.description}
            title={buildingStore.openMenuConfrimModal?.title}
          />
        )}
      </div>
    </>
  );
};

export default observer(BuildingMenu);
